"use strict";

define('rs/notifications/notifications.view',['vertebrae', 'rs/components/scroll-bottom', 'rs/helper'], function (Vertebrae, ScrollBottom, helper) {
  var NotificationsView = Vertebrae.View.extend({
    events: {
      'click': 'handleGeneralClick',
      'click .notification-item': 'handleNotificationItemClick',
      'click .notification-remove': 'handleNotificationRemoveClick',
      'click .notification-remove-all': 'handleNotificationRemoveAllClick'
    },
    templates: {
      'notifications.init': 'renderInitFragment'
    },
    render: function render() {
      var delegate = this.getDelegate();
      this.$el.html(this.renderInitFragment(delegate.getTemplateProperties()));
      this.trigger('render');
      this.setupScroll();
    },
    setupPosition: function setupPosition(pos) {
      this.$el.css({
        left: 'auto',
        right: pos.right + 'px'
      });
    },
    setupScroll: function setupScroll() {
      var delegate = this.getDelegate(),
        scroll = ScrollBottom(this.$('.notification-container'), _.bind(delegate.trigger, delegate, 'scroll:bottom'));
      this.once('render', scroll.remove);
      this.once('destroy', scroll.remove);
    },
    refreshNotifications: function refreshNotifications() {
      var delegate = this.getDelegate(),
        items = delegate.getNotifications(),
        container = this.$('.notification-items'),
        item = null,
        i = 0,
        len = items ? items.length : 0;
      container.empty();
      for (i = 0; i < len; ++i) {
        item = items[i];
        container.append(this.template(item.template || delegate.template, item, true));
      }
    },
    show: function show() {
      this.bindToBody();
      this.$el.show();
    },
    bindToBody: function bindToBody() {
      var delegate = this.getDelegate(),
        that = this;
      this._bodyBindTimeout = setTimeout(function () {
        $('body').on('click.notifications-view-' + that.cid, function () {
          delegate.setOpen(false);
        });
      }, 1);
    },
    unbindToBody: function unbindToBody() {
      clearTimeout(this._bodyBindTimeout);
      $('body').off('click.notifications-view-' + this.cid);
    },
    hide: function hide() {
      this.unbindToBody();
      this.$el.hide();
    },
    handleNotificationItemClick: function handleNotificationItemClick(ev) {
      var data = helper.datum(ev.currentTarget);
      if (data) {
        this.getDelegate().requestNotificationDispatch(data);
      }
    },
    handleNotificationRemoveClick: function handleNotificationRemoveClick(ev) {
      var data = helper.datum($(ev.currentTarget).closest('.notification-item'));
      if (data) {
        this.getDelegate().requestNotificationRemove(data);
      }
    },
    handleNotificationRemoveAllClick: function handleNotificationRemoveAllClick() {
      this.getDelegate().requestNotificationRemoveAll();
    },
    handleGeneralClick: function handleGeneralClick(ev) {
      ev.stopPropagation();
    }
  });
  return NotificationsView;
});

